module.exports = "665b9049e6d725afdd71a61ac42b5efa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/ninja-spritesheet.png
// module id = 79
// module chunks = 0